import { createFileRoute } from "@tanstack/react-router";
import { TaskDetailRedirect } from "@client/components/doc-generation/task-detail-redirect";

export const Route = createFileRoute("/_app/doc-generation/$taskId/")({
  component: TaskDetail,
});

function TaskDetail() {
  const { taskId } = Route.useParams();
  return <TaskDetailRedirect taskId={taskId} />;
}
